module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jrs-c0e9198a2ac4a66dcfcb7a96da339e13.svg";